<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <search-part ref="searchPart" @search="search" @add="add"/>
      <el-table :data="batches" class="header-list store border-black" border @row-click="showDetail"
                :header-row-class-name="'headerClass'" v-loading="loadingData" style="width: 100%">
        <el-table-column prop="logisticsCentreName" label="物流中心" min-width="160" :sortable="true">
          <template slot-scope="scope">
            <span>{{scope.row.logisticsCompanyName}}</span>
            <span v-show="scope.row.logisticsCentreName">-{{scope.row.logisticsCentreName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="货主" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="goodsName" label="货品" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="specification" label="规格" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="factoryName" label="生产厂商" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="supplyManufacturersName" label="供货单位" min-width="160" :sortable="true"></el-table-column>
        <el-table-column prop="batchNumber" label="批号" :sortable="true" width="150"></el-table-column>
        <el-table-column prop="count" label="盘点数量" :sortable="true" width="110"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :sortable="true" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="text-center mt-10" v-show="batches.length&&!loadingData">
        <el-pagination :current-page="pager.currentPage" :page-size="20"
                       :page-sizes="[20,50,100]"
                       :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <page-right :show="showAddPart" @right-close="resetRightBox" :css="{'width':'700px','padding':0}">
        <edit-form :currentItem="currentItem" :showAddPart="showAddPart" @close="resetRightBox" @change="addChange"></edit-form>
      </page-right>
      <page-right :show="showDetailPart" @right-close="resetRightBox" :css="{'width':'900px','padding':0}">
        <detail :currentItem="currentItem" :showDetailPart="showDetailPart" @close="resetRightBox"></detail>
      </page-right>
    </div>
  </div>
</template>
<script type="text/jsx">
  import {BspInventory} from '@/resources';
  import validMixin from '@/mixins/vaildMixin';
  import SearchPart from './search';
  import editForm from './form/editForm';
  import detail from './form/detail.vue';

  export default {
    components: {SearchPart, editForm, detail},
    mixins: [validMixin],
    data() {
      return {
        loadingData: true,
        showDetailPart: false,
        showAddPart: false,
        filters: {
          effectiveFlag: true
        },
        batches: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        },
        currentItemId: '',
        currentItem: {}
      };
    },
    mounted() {
      this.getBatches(1);
    },
    methods: {
      isValid(item) {
        let a = this.$moment();
        let b = this.$moment(item.expiryDate);
        let days = b.diff(a, 'days');
        return a < b ? days > 90 ? 2 : 1 : 0;
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getBatches(1);
      },
      handleCurrentChange(val) {
        this.getBatches(val);
      },
      getBatches(pageNo) { // 得到波次列表
        this.pager.currentPage = pageNo;
        this.batches = [];
        let params = Object.assign({
          pageNo: pageNo,
          pageSize: this.pager.pageSize,
          orgId: this.$store.state.user.userCompanyAddress
        }, this.filters);
        this.loadingData = true;
        BspInventory.query(params).then(res => {
          this.batches = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
      },
      showDetail(item) {
        this.showDetailPart = true;
        this.currentItemId = item.id;
        this.currentItem = item;
      },
      resetRightBox() {
        this.showDetailPart = false;
        this.showAddPart = false;
      },
      search(val) {
        Object.assign(this.filters, val);
        this.getBatches(1);
      },
      add() {
        this.showAddPart = true;
        this.currentItem = {};
      },
      addChange() {
        this.getBatches(1);
        this.resetRightBox();
      }
    }
  };
</script>
